/**
 * Mobile Menu Item Component
 * Click-only behavior for mobile menu items (no hover)
 */

class MobileMenuItem extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    
    if (this.details && this.summary) {
      // Only use click events, no hover
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      this.details.addEventListener('toggle', this.onToggle.bind(this));
    }
  }

  onSummaryClick(event) {
    // Let the default details behavior handle the toggle
    // This ensures click-only behavior
  }

  onToggle() {
    const isOpen = this.details.hasAttribute('open');
    this.summary.setAttribute('aria-expanded', isOpen);
    
    // Close other open menus in the same container (optional)
    if (isOpen) {
      const container = this.closest('nav, ul');
      if (container) {
        container.querySelectorAll('mobile-menu-item details[open]').forEach(detail => {
          if (detail !== this.details) {
            detail.removeAttribute('open');
          }
        });
      }
    }
  }
}

customElements.define('mobile-menu-item', MobileMenuItem);

